import { useState } from 'react';
import { FaPython, FaJs, FaNode, FaFileCode, FaTools, FaDatabase, FaLinux, FaAws } from "react-icons/fa";
import { SiCplusplus, SiExpress, SiApachespark, SiMicrosoftazure, SiMongodb, SiMysql, SiPostgresql, SiPandas, SiNumpy, SiTensorflow, SiOpencv, SiScikitlearn, SiFramework } from "react-icons/si";
import { GrReactjs } from "react-icons/gr";
import '../styles/accordion.css'
import { IoLibrary } from "react-icons/io5";
import { TbBrandGithubFilled, TbCloudComputing } from "react-icons/tb";
import {FaTimes, FaPlus} from 'react-icons/fa'
import styled from 'styled-components';
import {
    PaddingContainer,
    FlexContainer,
    Heading,
    ParaText,
    BlueText,
    IconContainer,
} from '../styles/Global.Styled';
import '../styles/accordion.css';
import { SkillsCardContainer } from '../styles/MySkills.styles';
import { fadeInRightVariant } from '../utils/Variants';

const MySkills = () => {
    const [activeIndex, setActiveIndex] = useState(-1);
    const handleClick = (index) => {
        setActiveIndex(index === activeIndex ? -1 : index);
    };

    const programmingLanguages = [
        { name: "Python", icon: <FaPython /> },
        { name: "JavaScript", icon: <FaJs /> },
        { name: "C++", icon: <SiCplusplus /> },
    ];

    const frameworks = [
        { name: "Node.js", icon: <FaNode /> },
        { name: "Express.js", icon: <SiExpress /> },
        { name: "PySpark", icon: <SiApachespark /> }
    ];

    const databases = [
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "MySQL", icon: <SiMysql /> },
        { name: "PostgreSQL", icon: <SiPostgresql /> }
    ];

    const libraries = [
        { name: "Pandas", icon: <SiPandas /> },
        { name: "Numpy", icon: <SiNumpy /> },
        { name: "Scikit-learn", icon: <SiScikitlearn /> },
        { name: "Open CV", icon: <SiOpencv /> },
        { name: "React.js", icon: <GrReactjs /> },
        { name: "TensorFlow", icon: <SiTensorflow /> }
    ];

    const tools = [
        { name: "Git and Github", icon: <TbBrandGithubFilled /> },
        { name: "Jupyter Notebook", icon: <IoLibrary /> },
        { name: "Google Colab", icon: <IoLibrary /> },
        { name: "Linux", icon: <FaLinux /> }
    ];

    const clouds = [
        { name: "Azure", icon: <SiMicrosoftazure /> },
        { name: "AWS", icon: <FaAws /> }
    ];

    const items = [
        {
            title: "Languages",
            icon: <FaFileCode />,
            content: (
                <FlexContainer gap="20px">
                    {programmingLanguages.map((language, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{language.icon}</IconContainer>
                            <span style={{ color: 'white' }}>{language.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },
        {
            title: "Frameworks",
            icon: <SiFramework />,
            content: (
                <FlexContainer gap="20px">
                    {frameworks.map((framework, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{framework.icon}</IconContainer>
                            <span className="title" style={{ color: 'white' }}>{framework.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },
        {
            title: "Databases",
            icon: <FaDatabase />,
            content: (
                <FlexContainer gap="10px">
                    {databases.map((language, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{language.icon}</IconContainer>
                            <span style={{ color: 'white' }}>{language.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },
        {
            title: "Libraries",
            icon: <IoLibrary />,
            content: (
                <FlexContainer gap="10px">
                    {libraries.map((library, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{library.icon}</IconContainer>
                            <span style={{ color: 'white' }}>{library.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },
        {
            title: "Tools and Technologies",
            icon: <FaTools />,
            content: (
                <FlexContainer gap="10px">
                    {tools.map((tool, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{tool.icon}</IconContainer>
                            <span style={{ color: 'white' }}>{tool.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },

        {
            title: "Cloud Platforms",
            icon: <TbCloudComputing />,
            content: (
                <FlexContainer gap="10px">
                    {clouds.map((cloud, index) => (
                        <div key={index}>
                            <IconContainer size="2rem" color='white'>{cloud.icon}</IconContainer>
                            <span style={{ color: 'white' }}>{cloud.name}</span>
                        </div>
                    ))}
                </FlexContainer>
            ),
        },
    ];
    const headingStyle = {
        background: '#3E88D1',
        backgroundImage: 'linear-gradient(to right, #3E88D1 0%, #0ABCF9 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',

    };

    // return (
    //     <PaddingContainer id="Skills" top="5%" bottom="10%" responsiveLeft="1rem" responsiveRight="1rem">
    //         <FlexContainer responsiveFlex responsiveDirection="column-reverse" fullWidthChild>
    //             <SkillsCardContainer>
    //                 <div className="accordionDiv">
    //                     {items.map((item, index) => (
    //                         <div key={item.title} id="accordion" className="accordionItem">
    //                             <button className='accordionButton' onClick={() => handleClick(index)}>
    //                                 <IconContainer size="2rem" color='white' style={{marginRight: '10px'}}>{item.icon}</IconContainer>
    //                                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    //                                     <span className="titles"style={{ color: 'white' }}>{item.title}</span>
    //                                 </div>
    //                             </button>
    //                             {index === activeIndex && (
    //                                 <div className="accordionContent">
    //                                     {item.content}
    //                                     <div className="accordionIcons">
    //                                         {/* {index === activeIndex ? <BsDashSquare /> : <BsPlusSquare />} */}
    //                                     </div>
    //                                 </div>
    //                             )}
    //                         </div>
    //                     ))}
    //                 </div>
    //             </SkillsCardContainer>
    return (
        <PaddingContainer id="Skills" top="5%" bottom="10%" responsiveLeft="1rem" responsiveRight="1rem">
            <FlexContainer responsiveFlex responsiveDirection="column-reverse" fullWidthChild>
                <SkillsCardContainer>
                    <div className="accordionDiv">
                        {items.map((item, index) => (
                            <div key={item.title} id="accordion" className="accordionItem">
                                <button className='accordionButton' onClick={() => handleClick(index)}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <IconContainer size="2rem" color='white' style={{marginRight: '10px'}}>{item.icon}</IconContainer>
                                        <span className="titles"style={{ color: 'white' }}>{item.title}</span>
                                    </div>

                                </button>
                                {index === activeIndex && (
                                    <div className="accordionContent">
                                        {item.content}
                                        {/* Your accordion content */}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </SkillsCardContainer>

                <div variants={fadeInRightVariant} initial="hidden" whileInView="visible">
                    <Heading as="h4" size="h4">
                        MY SKILLS
                    </Heading>
                    <Heading as="h2" size="h2" top="0.5rem">
                        What <BlueText style={headingStyle}>I can do</BlueText>
                    </Heading>

                    <ParaText top="2rem" bottom="1.5rem">
                    Enthusiastic about artificial intelligence, I've crafted significant language models using LangChain and Google Generative AI. My expertise extends to NLP projects, tackling diverse classification and regression tasks with classical machine learning algorithms
                    <br></br><br></br>
                    Proficient in leveraging cloud platforms for AIML tasks and data engineering, I employ Apache Spark's PySpark framework for efficient data processing. 
                    <br></br><br></br>
                    Beyond that, I've successfully developed user-friendly, full-stack websites using the MERN Stack. With a keen eye for seamless deployment, I ensure these projects thrive on cloud platforms.
   
                    </ParaText>
                </div>
            </FlexContainer>
        </PaddingContainer>
    );
};

export default MySkills;
